import { render } from "./d-good-road-panel.vue?vue&type=template&id=4ed00d42&scoped=true&ts=true"
import script from "./d-good-road-panel.vue?vue&type=script&lang=ts"
export * from "./d-good-road-panel.vue?vue&type=script&lang=ts"

import "./d-good-road-panel.vue?vue&type=style&index=0&id=4ed00d42&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed00d42"]])

export default __exports__